import React from "react";
import * as FaIcons from "react-icons/fa";

const R13HomeSurvey = ({ formData, onFormDataChange, validationCheck }) => {
  const { firstName, accessToComputerAtHome, accessToTheInternetAtHome } =
    formData;
  return (
    <>
      {/* Home Survey */}
      <div className="sub-form">
        <h3>Home Survey</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Does {firstName === "" ? "the Student" : firstName} have Access to
              Computer at Home?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(accessToComputerAtHome["yes"] || accessToComputerAtHome["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={accessToComputerAtHome["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="accessToComputerAtHome"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={accessToComputerAtHome["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="accessToComputerAtHome"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Does {firstName === "" ? "the Student" : firstName} have Access to
              the Internet at Home?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  accessToTheInternetAtHome["yes"] ||
                  accessToTheInternetAtHome["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={accessToTheInternetAtHome["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="accessToTheInternetAtHome"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={accessToTheInternetAtHome["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="accessToTheInternetAtHome"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default R13HomeSurvey;
